import { CSSProperties } from 'react';

export const IDME_VERIFY_BUTTON_IMG_SRC = 'https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg';
export const IDME_VERIFY_BUTTON_IMG_ALT = 'Verify with ID.me';
export const IDME_VERIFY_BUTTON_IMG_STYLES: CSSProperties = { maxWidth: '100%', height: '42px' };
export const IDME_WEB_CLOSED_CHECK_INTERVAL_MS = 500;
export const IDME_VERIFICATION_CLOSE_URL_PATH = 'identity-verification/idme/authorization-callback/close';
